import React from 'react';

import { Badge, cn } from '@column/ui';

export type StatusBadgeTone = 'default' | 'success' | 'warning' | 'danger' | 'info';

const toneClassName: Record<StatusBadgeTone, string> = {
  default: 'border-gray-700/10 bg-gray-100/60 text-gray-600 dark:border-white/10 dark:bg-white/5 dark:text-gray-300',
  success:
    'border-seafoam-700/10 bg-seafoam-100/50 text-seafoam-700 dark:border-seafoam-400/20 dark:bg-seafoam-500/15 dark:text-seafoam-300',
  warning:
    'border-yellow-700/10 bg-yellow-100/50 text-yellow-700 dark:border-yellow-400/20 dark:bg-yellow-500/15 dark:text-yellow-300',
  danger: 'border-red-700/10 bg-red-100/50 text-red-600 dark:border-red-400/20 dark:bg-red-500/15 dark:text-red-300',
  info: 'border-blue-700/10 bg-blue-100/50 text-blue-600 dark:border-blue-400/20 dark:bg-blue-500/15 dark:text-blue-300',
};

export const StatusBadge: React.FC<React.PropsWithChildren<{ tone?: StatusBadgeTone; className?: string }>> = ({
  tone = 'default',
  className,
  children,
}) => (
  <Badge
    variant="outline"
    className={cn(
      'gap-1 rounded-md px-2 py-0.5 leading-4 [&>svg]:-ml-0.5 [&>svg]:shrink-0 [&>svg]:[--icon-size-x:14px] [&>svg]:[--icon-size-y:14px] [&>svg]:[--icon-size:14px]',
      toneClassName[tone],
      className
    )}
  >
    {children}
  </Badge>
);
